import { z } from 'zod';

export const IMAGE_MAX_WIDTH = 1000;
export const IMAGE_MAX_HEIGHT = 1000;
export const IMAGE_MIN_WIDTH = 500;
export const IMAGE_MIN_HEIGHT = 500;

/** Manzanita.Catalog.ManzanitaSortedImage */
export interface SortedImage {
	smallImageUrl: string;
	largeImageUrl: string;
	sortOrder: number;
}

/** Manzanita.Catalog.ManzanitaSortedImage */
export const sortedImageSchema = z.object({
	smallImageUrl: z.string(),
	largeImageUrl: z.string(),
	sortOrder: z.number(),
}) satisfies z.ZodType<SortedImage>;

export interface ImageDimensions {
	width: number;
	height: number;
}
